/* AVRA_CARD_ALT_TOUCH (2026-09-20)
   Phones cannot hover, so a product card's second photo needs another way
   in. Two, in fact:

   1. The DOTS under every photo. A tap flips it. Works everywhere, including
      inside a carousel.
   2. A SIDEWAYS SWIPE on the photo - but only on grid pages. Inside a
      carousel, a sideways swipe belongs to the carousel; if it flipped the
      photo instead, carousels would stop scrolling on every phone.

   Everything is delegated from document, so cards added after load (a
   filter, a "load more") work without being re-bound.

   Styles: assets/avra-card-alt.css. Markup: snippets/avra-product-card.liquid.
   Delete this file and its <script> tag in layout/theme.liquid and phones
   return to their previous behaviour exactly. */
(function () {
  'use strict';

  var touchQ = window.matchMedia ? window.matchMedia('(hover: none), (pointer: coarse)') : null;
  function isTouch() { return !!(touchQ && touchQ.matches); }

  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }

  function setAlt(card, on) {
    var media = card.querySelector('.prod__media--alt');
    if (!media) return;
    media.classList.toggle('is-alt', on);
    var dots = card.querySelector('.prod__dots');
    if (dots) dots.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  /* 1. Dots - a tap flips the photo either way. */
  document.addEventListener('click', function (e) {
    var dots = closest(e.target, '.prod__dots');
    if (!dots) return;
    var card = closest(dots, '.prod');
    if (!card) return;
    var media = card.querySelector('.prod__media--alt');
    if (!media) return;
    setAlt(card, !media.classList.contains('is-alt'));
  });

  /* 2. Swipe - grid pages only. */
  var startX = 0, startY = 0, active = null, swipedAt = 0;

  document.addEventListener('touchstart', function (e) {
    active = null;
    if (!isTouch() || e.touches.length !== 1) return;
    var media = closest(e.target, '.prod__media--alt');
    if (!media) return;
    if (closest(media, '[data-carousel], .carousel')) return; /* carousel owns sideways */
    active = media;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!active) return;
    var t = e.changedTouches && e.changedTouches[0];
    var media = active;
    active = null;
    if (!t) return;

    var dx = t.clientX - startX;
    var dy = t.clientY - startY;

    /* Clearly sideways, and far enough to be deliberate. A vertical scroll
       that drifts a little is never mistaken for a swipe. */
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      var card = closest(media, '.prod');
      if (card) setAlt(card, dx < 0); /* swipe left = next photo, right = back */
      swipedAt = Date.now();
    }
  }, { passive: true });

  document.addEventListener('touchcancel', function () { active = null; }, { passive: true });

  /* A swipe must never also open the product. Only clicks within half a
     second of a swipe are stopped, so the next genuine tap always works. */
  document.addEventListener('click', function (e) {
    if (!swipedAt || Date.now() - swipedAt > 500) return;
    swipedAt = 0;
    if (closest(e.target, '.prod__media--alt')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();
